{{businessName}} has been approved for funding from <span [class]="companyCssClass">{{companyName}}</span>.<br>See offer details below.